"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.basicGridStyles = void 0;
var _constants = require("../../constants");
const basicGridStyles = theme => ({
  alignItems: 'end',
  display: 'grid',
  gap: theme.spacing(3),
  gridTemplateColumns: `repeat(auto-fill, ${_constants.ITEM_WIDTH}px)`,
  justifyContent: 'space-around',
  padding: theme.spacing(0, 3),
  position: 'relative',
  [theme.breakpoints.only('xs')]: {
    gap: theme.spacing(2),
    gridTemplateColumns: `repeat(auto-fill, ${_constants.ITEM_WIDTH_XS}px)`,
    padding: theme.spacing(0, 2)
  },
  [theme.breakpoints.down(_constants.XXS)]: {
    gap: theme.spacing(2),
    gridTemplateColumns: `repeat(auto-fill, ${_constants.ITEM_WIDTH_XXS}px)`,
    padding: theme.spacing(0, 1)
  }
});
exports.basicGridStyles = basicGridStyles;